import createPmkinoWebAppState from "./createPmkinoWebAppState"

const setPmkinoWebAppState = () => {
    try {
        const state = createPmkinoWebAppState()
        const jsonState = JSON.stringify(state)
        setPmkinoWebAppStateInternal(jsonState)
    } catch (error) {
        logError(error)
    }
}

function setPmkinoWebAppStateInternal(jsonState){
    if (typeof pmkinoWebappAndroid != "undefined" && typeof pmkinoWebappAndroid.setWebAppState === "function") {
        // Android
        pmkinoWebappAndroid.setWebAppState(
            jsonState
        )
    } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.setWebAppState) {
        // IOS
        window.webkit.messageHandlers.setWebAppState.postMessage({
            state: jsonState
        });
    }
}

function logError(error){
    if (typeof pmkinoWebappAndroid != "undefined" && typeof pmkinoWebappAndroid.logError === "function") {
        pmkinoWebappAndroid.logError("An error occured in setPmkinoWebAppState: " + err?.message)
    }
}

export default setPmkinoWebAppState